import { render } from "./CloseCross.vue?vue&type=template&id=3d6aa99a&scoped=true"
import script from "./CloseCross.vue?vue&type=script&lang=js"
export * from "./CloseCross.vue?vue&type=script&lang=js"

import "./CloseCross.vue?vue&type=style&index=0&id=3d6aa99a&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d6aa99a"]])

export default __exports__